import { render, staticRenderFns } from "./Purcsale.vue?vue&type=template&id=f9a9db92&scoped=true"
import script from "./Purcsale.vue?vue&type=script&lang=js"
export * from "./Purcsale.vue?vue&type=script&lang=js"
import style0 from "./Purcsale.vue?vue&type=style&index=0&id=f9a9db92&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f9a9db92",
  null
  
)

export default component.exports